module.exports = __webpack_public_path__ + "static/media/completed_active.24e055e0.svg";